<div class="flexStudents">

  
  <span class="flexLeft">
    <button mat-icon-button (click)="navigate()" class="mediumIcon">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="headline6">{{'admin.domiciliacion.remittance' | translate}} {{selectedMonth.date}}</span>
  </span>
  
  <div>
    <button [disabled]="totalElements == 0"mat-raised-button class="primaryButton2" color="primary" (click)="export()">
      <mat-icon svgIcon="xml" *ngIf="totalElements != 0"></mat-icon>
      <mat-icon svgIcon="xml_disable" *ngIf="totalElements == 0"></mat-icon>
      <span *ngIf="!isMobile">
        {{ 'admin.domiciliacion.export' | translate }}
      </span>
     
    </button>
    <br/>
    <p *ngIf="totalElements > 0 " class="body3">{{ 'admin.domiciliacion.exportTextA' | translate }} {{totalElements}} {{ 'admin.domiciliacion.exportTextB' | translate }}</p>
  </div>
</div>


<app-filters-domiciliacion (filtersChangeEvent)="filtersChange($event)"></app-filters-domiciliacion>

<div class="noData" *ngIf="loaded && noData">
    <span class="headline6Light"> {{'admin.domiciliacion.mainTable.emptyAlumnos' | translate}}</span>
  </div>
  
  <div class="table-container" *ngIf="loaded && !noData">
    <table *ngIf="!isMobile" mat-table [dataSource]="domiciliacionData" multiTemplateDataRows>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.name' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.nombre}} {{element.apellido}}</span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="trainingGroup">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.type' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.entrenamientoTipoDescripcion}}</span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="tariff">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.tariff' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.arancel}} 
            <button mat-icon-button>
              <mat-icon id="editButton" class="delete" (click)="editarArancel(element)">
                edit
              </mat-icon>
            </button>
          </span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.date' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.creado | date: 'dd/MM/YYYY'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.status' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2" *ngIf="element.estado == 'N'"> {{'status.N' | translate}}</span>
          <span class="subtitle2" *ngIf="element.estado == 'E'"> {{'status.E' | translate}}</span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.actions' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="flexActions">
            <button mat-icon-button (click)="exportElement(element)" color="primary" [checked]="element.leido">
              <!-- fixme: no se ve el ícono es color blanco como el fondo -->
              <mat-icon svgIcon="xml_blue" class="iconXml"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>



    <table *ngIf="isMobile" mat-table [dataSource]="domiciliacionData" multiTemplateDataRows>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.name' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.nombre}} {{element.apellido}}</span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="tariff">
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.tariff' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <span class="subtitle2">{{element.arancel}} 
            <button mat-icon-button>
              <mat-icon id="editButton" class="delete" (click)="editarArancel(element)">
                edit
              </mat-icon>
            </button>
          </span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef> {{'admin.studentsTable.header.actions' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="flexActions">
            <button mat-icon-button (click)="exportElement(element)" color="primary" [checked]="element.leido">
              <!-- fixme: no se ve el ícono es color blanco como el fondo -->
              <mat-icon svgIcon="xml_blue" class="iconXml"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumnsMobile"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsMobile;"></tr>
    </table>
  
  </div>
  
  <app-paginator-complete *ngIf="loaded" 
    [first]="first" 
    [last]="last" 
    [page]="page" 
    [totalPages]="totalPages"
    [size]="size" 
    [totalElements]="totalElements" 
    (loadMoreEvent)="loadMore($event)">
  </app-paginator-complete>